import http from "../../http";

export default {
  list(params) {
    return http.get("cmsservice/cms_product/page", params);
  },
  listAll(params) {
    return http.get("cmsservice/cms_product/page/share", params);
  },
  info(id) {
    return http.get("cmsservice/cms_product/info/" + id, {});
  },
  add(params) {
    return http.post("cmsservice/cms_product/add", params);
  },
  update(params) {
    return http.post("cmsservice/cms_product/update", params);
  },
  del(params) {
    return http.post("cmsservice/cms_product/delete", params);
  },
  //上架下架
  status(params) {
    return http.get("cmsservice/cms_product/status", params);
  },
  //产品置顶
  top(params) {
    return http.get("cmsservice/cms_product/top", params);
  },
  type: {
    tree(params) {
      return http.get("cmsservice/productSort/tree", params);
    },
    add(params) {
      return http.post("cmsservice/productSort/add", params);
    },
    update(params) {
      return http.put("cmsservice/productSort/update", params);
    },
    del(id) {
      return http.delete("cmsservice/productSort/del/" + id, {});
    },
  },
};
